import Carousel from 'Assets/js/lib/carousel'
;(function () {
  const components = {
    techFeaturesCarousel: SAXX.Init.Component((node) => {
      new Carousel(node, { cell: '.tech-features--item' })
    }),
  }
  Object.assign(SAXX.Init.Components, components)
})()
